import React from 'react';
import {LandingPagePropTypes} from '@ignitesales/neuro-application';
import {LandingPageMessage, LandingPageTitle} from "../../../../../../../shared/js/core-components/LandingPageMessages";
import {getBackgroundImgStyle, generateBackgroundImageUrl} from "../../../../../../../shared/js/utils/themeHelper.mjs";
import DialogueClientLogo from "../../../../../../../shared/js/core-components/DialogueClientLogo";
import LandingPageStartButton from "../../../../../../../shared/js/core-components/LandingPageStartButton";
import {useThemeSettings} from "../../../../../../../shared/js/hooks/useThemeSettings.mjs";
import classnames from "classnames";

const getLandingPagePatternStyle = (patternKey, patternColorKey) => {
    const [colorKey, opacityValue] = (patternColorKey || 'b-10').split('-');
    const colorToUse = colorKey === 'b' ? 'black' : 'white';
    const opacityToUse = opacityValue / 100;
    const backgroundImageUrl = generateBackgroundImageUrl(patternKey, `/classpath/assets/images/bg-${patternKey || 'ignite'}--${colorToUse}.png`);
    const patternStyle = getBackgroundImgStyle(backgroundImageUrl);
    return {
        ...patternStyle,
        opacity: opacityToUse
    };
};
const defaultBackgroundImage = 'https://ignite-dialogue-theme-assets.s3.amazonaws.com/theme-testing/ignite-landing.jpg';

const LandingPage = ({ componentClass }) => {
    const { landingPageType, getLandingThemeConfigs, getGeneralThemeConfigs } = useThemeSettings();
    const { pattern, patternColor } = getGeneralThemeConfigs();
    const { imageUrl, imagePosition, animationType } = getLandingThemeConfigs();
    const patternStyle = getLandingPagePatternStyle(pattern, patternColor);
    const bannerImageStyle = getBackgroundImgStyle(imageUrl || defaultBackgroundImage);
    const classes = classnames(componentClass, {
        [`${componentClass}--leftAligned`]: imagePosition === 'left',
        [`${componentClass}--noImage`]: landingPageType === 'noImage'
    });
    const bannerTextClasses = classnames(`${componentClass}__bannerText`, {
        isCentered: landingPageType === 'noImage',
    });
    const patternBgClasses = classnames(`${componentClass}__patternBackground`, {
        isAnimated: landingPageType === 'noImage' && animationType === true
    });

    return <section className={classes}>
        { landingPageType === 'default' && <div className={`${componentClass}__bannerImage`} style={bannerImageStyle} /> }
        <div className={bannerTextClasses}>
            <DialogueClientLogo className={`${componentClass}__logo`} />
            <LandingPageTitle tagName="h1" />
            <LandingPageMessage tagName="p" />
            <div><LandingPageStartButton /></div>
        </div>
        <div className={`${componentClass}__patternContainer`}>
            <div className={patternBgClasses} style={patternStyle} />
        </div>
    </section>;
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
